class Accordion extends HTMLElement {
  constructor() {
    super();
    this.active = undefined;
    this.toggle = undefined;
    this.content = undefined;
  }

  connectedCallback() {
    this.active = this.getAttribute('data-active') === 'true';
    this.toggle = this.querySelector('[data-toggle]');
    this.content = this.querySelector('[data-content]');

    // Set up ARIA attributes
    this.toggle.setAttribute('aria-expanded', this.active.toString());
    this.toggle.setAttribute('aria-controls', this.content.id || this.generateId());
    this.content.setAttribute('id', this.content.id || this.generateId());
    this.content.setAttribute('aria-labelledby', this.toggle.id || this.generateId());
    this.toggle.setAttribute('id', this.toggle.id || this.generateId());

    this.toggle.addEventListener('click', this.handleToggleClick.bind(this));
  }

  disconnectedCallback() {
    this.toggle.removeEventListener('click', this.handleToggleClick.bind(this));
  }

  generateId() {
    return 'accordion-' + Math.random().toString(36).substr(2, 9);
  }

  open() {
    this.active = true;
    this.setAttribute('data-active', true);
    this.toggle.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => this.setAttribute('data-opening', true));
  }

  close() {
    this.active = false;
    this.toggle.setAttribute('aria-expanded', 'false');
    const onTransitionEnd = () => {
      this.setAttribute('data-active', false);
      this.content.removeEventListener('transitionend', onTransitionEnd);
    };

    this.content.addEventListener('transitionend', onTransitionEnd);
    this.setAttribute('data-opening', false);
  }

  handleToggleClick() {
    if (this.active === true) {
      this.close();
    } else {
      this.open();
    }
  }
}

if (!customElements.get('accordion-component')) {
  customElements.define('accordion-component', Accordion);
}
